import React from "react";
import "./Logo.css"
import logoImg from "../../../resources/logo.png";

const logo = () => <img src={logoImg} className="logo" alt="logo"/>;

export default logo;